import { ArrowLeftOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';

import goa from '../../assets/images/goa.jpg'
import manali from '../../assets/images/manali.jpg'
import singapore from '../../assets/images/singapore.jpg'
import abu from '../../assets/images/abu-dhabi.jpg'
import ooty from '../../assets/images/ooty.jpg'
import kashmir from '../../assets/images/kashmir.jpg'
import Varnasi from '../../assets/images/varansi.jpg'
import murugan from '../../assets/images/domestic.jpeg'
import kerela from '../../assets/images/kerela.jpg'
import Darjeeling from '../../assets/images/darjeeling.jpg'
import Ladakh from '../../assets/images/leh-ladak-.jpg'
import clock from '../../assets/images/clock.png'
import Group from '../../assets/images/people.png';
import SmoothScroll from '../SmoothScroll'

const DomestDetails = ({ setActiveTab, details }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);


  return (
    <>
      <SmoothScroll />
      <div className='packageDetails'>
        <h4><span style={{ marginRight: 10, cursor: "pointer" }} onClick={() => setActiveTab(false)}><ArrowLeftOutlined /> </span>{details.place} Package</h4>

        <div className='package-full-details'>
          <Row gutter={[20, 30]}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div className='package-details-slider'>

                <Swiper
                  style={{
                    '--swiper-navigation-color': '#fff',
                    '--swiper-pagination-color': '#fff',
                  }}
                  loop={true}
                  spaceBetween={10}
                  navigation={true}
                  thumbs={{ swiper: thumbsSwiper }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper2"
                >
                  {details.imgs.map((img) =>
                    <SwiperSlide>
                      <img src={img} style={{ maxHeight: 450 }} />
                    </SwiperSlide>
                  )}

                </Swiper>


                <div className='packages-slider-details'>
                  <div style={{ display: "flex", gap: 30, alignItems: "center" }}>
                    <img src={clock} alt='clock' width={50} height={50} />
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      <span style={{ color: "#7e9a9f", margin: 0, fontFamily: "Outfit", textAlign: "left" }}>Duriation</span>
                      <p style={{ color: "#7e9a9f", margin: 0, fontFamily: "Outfit", textAlign: "left" }}>{details.tripDur}</p>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: 30, alignItems: "center" }}>
                    <img src={Group} alt='clock' style={{ position: "relative", top: 10 }} />
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 10 }}>
                      <span style={{ color: "#7e9a9f", margin: 0, fontFamily: "Outfit" }}>Max-members</span>
                      <p style={{ color: "#7e9a9f", margin: 0, fontFamily: "Outfit" }}>Unlimted</p>
                    </div>
                  </div>
                </div>

              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div className='package-details'>
                <h2>{details.tripDur}</h2>
                <ul>
                  {details.days.map((days) => {
                    return (
                      <li>
                        <h3>{days.title}</h3>
                        {/* <p>{days.desc}</p> */}
                        {days.desc.map((desc) => {
                          return (
                            <p>{desc}</p>
                          )
                        })}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>

        {details.days1 && <div className='package-full-details'>
          <Row gutter={[20, 30]}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className='package-details' style={{ height: 'auto' }}>
                <h2>{details.title}</h2>
                <p style={{marginBottom : "20px"}}>{details.subDesc}</p>
                <ul>
                  {details.days1.map((days) => {
                    const descLines = days.desc.split('\n');
                    return (
                      <li>
                        <h3>{days.title}</h3>
                        {descLines.map((line, lineIndex) => (
                          <p key={lineIndex} style={{ marginBottom: 10 }}>{line}</p>
                        ))}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>}
      </div>
    </>
  )
}

export default DomestDetails